export default {
    menuItems: [
      {
        name: 'ホーム',
        url: '/'
      },
      {
        name: '学校概要',
        url: '/about'
      },
      {
        name: '写真館',
        url: '/allubum'
      },
      {
        name: 'コメントフォーム',
        url: '/submitMessage'
      },
      {
        name: 'みんなのコメント',
        url: '/messageList'
      },
      {
        name: 'お問い合わせ',
        url: '/contact'
      }
    ],
    HomeItems: [
      {
        src: require('../assets/img/homeHero/IMG_6629.webp')
      },
      {
        src: require('../assets/img/homeHero/IMG_6839.webp')
      },
      {
        src: require('../assets/img/homeHero/IMG_7182.webp')
      },
    ],
    hisItems: [
      {
        time: '昭和22年',
        event1: '松尾中学校，豊岡中学校，太平中学校設立',
      },
      {
        time: '昭和33年',
        event1: '松尾・豊岡・大平の3中学校を統合して松尾町立松尾中学校となる',
      },
      {
        time: '昭和34年',
        event1: '新校舎（円形）竣工,全校生徒760名入校。実質統合に入る',
      },
      {
        time: '昭和35年',
        event1: '県PTA連協主催の本校PTA研究会開催',
      },
      {
        time: '昭和36年',
        event1: '別館管理校舎落成',
      },
      {
        time: '昭和43年',
        event1: '山武郡市中学校野球大会において優勝、山武郡市中学校総合体育大会において剣道・卓球男子団体優勝',
      },
      {
        time: '昭和45年',
        event1: '創立10周年記念式典',

      },
      {
        time: '昭和46年',
        event1: '山武郡市中学校総合体育大会において総合優勝',

      },
      {
        time: '昭和48年',
        event1: '教育功労賞の学校表彰を県教育委員会から受賞する',

      },
      {
        time: '昭和49年',
        event1: '体育倉庫新築完了',
      },
      {
        time: '昭和50年',
        event1: '山武郡市中学校総合体育大会において野球優勝',

      },
      {
        time: '昭和51年',
        event1: '交通安全教育優良校として県教育委員会から表彰を受ける',

      },
      {
        time: '昭和52年',
        event1: '山武郡市総合体育大会において，剣道男女団体，女子ソフトボール優勝',
      },
      {
        time: '昭和53年',
        event1: '山武郡市中学校総合体育大会において，剣道男女団体優勝',
      },
      {
        time: '昭和54年',
        event1: 'テニスコート完成、 山武郡市中学校総合体育大会において，剣道女子団体・個人優勝',

      },
      {
        time: '昭和55年',
        event1: '松尾町体育館落成式、山武郡市中学校体育大会において剣道女子団体・個人優勝、バスケットボール女子優勝 '

      },
      {
        time: '昭和58年',
        event1: '山武郡市中学校総合体育大会において，バスケットボール男子優勝',

      },
      {
        time: '昭和60年',
        event1: '松尾中学校武道館落成記念式典',

      },
      {
        time: '昭和62年',
        event1: '山武郡市中学校総合体育大会において，ソフトボール，ソフトテニス男子個人優勝、 県子ども県展4年連続学校賞受賞',

      },
      {
        time: '昭和63年',
        event1: '創立30周年記念式典挙行',

      },
      {
        time: '平成元年',
        event1: '県小・中・高書初展覧会学校優秀賞受賞',

      },
      {
        time: '平成2年',
        event1: '部室新設完了',

      },
      {
        time: '平成3年',
        event1: '松尾中学校PTA，千葉県PTA連絡協議会から団体表彰を受ける',

      },
      {
        time: '平成4年',
        event1: '山武郡市中学校総合体育大会においてソフトボール優勝、少年消防クラブが県少年婦人防火委員会から表彰を受ける',

      },
      {
        time: '平成5年',
        event1: '山武郡市中学校総合体育大会においてソフトボール優勝',

      },
      {
        time: '平成6年',
        event1: '山武郡市中学校総合体育大会においてソフトボール、柔道男子優勝',

      }, {
        time: '平成7年',
        event1: ' 適応指導推進研究校(県教育委員会)の指定を受ける、山武郡市中学校総合体育大会において，ソフトボール優勝',

      }, {
        time: '平成8年',
        event1: '山武郡市中学校総合体育大会において，柔道部女子個人優勝',

      }, {
        time: '平成9年',
        event1: '教育功労の学校表彰を県教育委員会から受賞する',

      }, {
        time: '平成10年',
        event1: '松尾中学校落成記念式典(竣工式)　グラウンド完成、山武郡市中学校総合体育大会において，ソフトボール優勝',

      }, {
        time: '平成11年',
        event1: '全国中学校陸上競技選手権大会に400m出場',

      }, {
        time: '平成12年',
        event1: '全日本アンサンブルコンテスト(吹奏楽)において銀賞受、山武郡市中学校総合体育大会において，ソフトボール優勝',

      }, {
        time: '平成13年',
        event1: '東関東アンサンブルコンテストにおいて銀賞・銅賞受賞',

      }, {
        time: '平成14年',
        event1: '関東中学校総合体育大会にソフトボール出場、バレーボール男子，ソフトボール優勝',

      }, {
        time: '平成15年',
        event1: '吹奏楽部アンサンブルコンテスト東関東大会において金賞受賞、全国中学校陸上競技選手権大会においてにおいて走り高跳び準優勝',

      },
      {
        time: '平成16年',
        event1: '東関東吹奏楽コンクール千葉大会において金賞受賞、山武郡市中学校総合体育大会において，ソフトボール，陸上男女総合優勝、千葉県吹奏楽コンクール本選(第1位)東関東大会出場決定',

      },
      {
        time: '平成17年',
        event1: '日本管楽合奏コンテスト全国大会審査員特別賞受賞、 全日本陸上競技選手権大会に800m出場',

      },
      {
        time: '平成18年',
        event1: '東関東吹奏楽コンクールにおいて金賞受賞',

      },
      {
        time: '平成26年',
        event1: '全国中学校選抜卓球大会出場',

      }
    ],
  }
